<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-lessEqual`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.42088 9.24025C3.60148 8.92057 4.00737 8.8078 4.32713 8.98829L12.3281 13.5049C12.6474 13.6856 12.7603 14.0906 12.5801 14.4102C12.3996 14.7298 11.9936 14.8434 11.6738 14.6631L3.67284 10.1465C3.35319 9.96592 3.24046 9.56 3.42088 9.24025ZM11.6738 1.33595C11.9936 1.15559 12.3995 1.26828 12.5801 1.5879C12.7604 1.9076 12.6476 2.31353 12.3281 2.49415L5.3535 6.43068L12.3281 10.3682C12.6477 10.5488 12.7605 10.9547 12.5801 11.2744C12.3996 11.5942 11.9936 11.7068 11.6738 11.5264L3.67284 7.01075C3.46406 6.89288 3.33507 6.67139 3.33495 6.43165C3.33495 6.19189 3.46413 5.97052 3.67284 5.85255L11.6738 1.33595Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineLessEqual',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
